import {RootState} from "../../../../store";

export const getConstantsAddictions = (state: RootState) => state.constantsReducer.interestAddiction;
export const getAddictions = (state: RootState) => state.constantsReducer.interestAddiction.collection;
